import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b7059c3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mod_wrap mod_c" }
const _hoisted_2 = { class: "mod_c_title establish_title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "轻问卷", -1))
const _hoisted_4 = { class: "establish" }
const _hoisted_5 = { class: "establish_top_name input_title" }
const _hoisted_6 = { class: "establish_top align_items" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "establish_top_name input_title",
  style: {"margin-right":"15px"}
}, "重复填写：", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "establish_top align_items" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, "问题编号(可选)：", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "establish_top_showSelect select_title" }, "显示样式(可选)：", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "establish_top_tip" }, "*菜单栏样式需前往自定义菜单添加菜单栏", -1))
const _hoisted_13 = { class: "establish_top align_items" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, "浮窗标题(中文)：", -1))
const _hoisted_15 = { class: "establish_top align_items" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, "浮窗标题(英文)：", -1))
const _hoisted_17 = { class: "question_draggable" }
const _hoisted_18 = { class: "question_top" }
const _hoisted_19 = { class: "question_left" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "select_title" }, "题目类型：", -1))
const _hoisted_21 = { class: "question_right" }
const _hoisted_22 = { class: "question_right_line align_items" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question_title input_title" }, "问题名称：", -1))
const _hoisted_24 = { class: "input_title text_number" }
const _hoisted_25 = { class: "question_right_line align_items" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question_title input_title" }, "问题备注：", -1))
const _hoisted_27 = { class: "input_title text_number" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { class: "question_title input_title" }
const _hoisted_30 = {
  key: 1,
  class: "question_right_line align_items"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question_title input_title" }, "每行显示：", -1))
const _hoisted_32 = {
  key: 2,
  class: "question_right_line align_items"
}
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question_title input_title" }, "最多可选：", -1))
const _hoisted_34 = {
  key: 3,
  class: "question_right_line align_items"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question_title input_title" }, "文本验证：", -1))
const _hoisted_36 = {
  key: 4,
  class: "question_right_line align_items"
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question_title input_title" }, "最多填写：", -1))
const _hoisted_38 = {
  key: 5,
  class: "question_right_line align_items"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question_title input_title" }, "尺寸  高：", -1))
const _hoisted_40 = {
  key: 6,
  class: "question_right_line align_items"
}
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question_title input_title" }, "量测类型：", -1))
const _hoisted_42 = { class: "align_items" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_title" }, "程度：", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_degree_line" }, "-", -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_degree_title input_title" }, "起始数值：", -1))
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input_degree_title input_title" }, "结束数值：", -1))
const _hoisted_47 = {
  key: 7,
  class: "question_right_line align_items"
}
const _hoisted_48 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question_title input_title" }, "文件大小限制：", -1))
const _hoisted_49 = {
  key: 8,
  class: "question_right_line align_items"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "question_title input_title" }, "文件格式限制：", -1))
const _hoisted_51 = { class: "question_buttom" }
const _hoisted_52 = ["onClick"]
const _hoisted_53 = { class: "establish_buttom" }

import Crumb from '@/components/Crumb.vue';
import { ref } from 'vue';
import http from '@/api/report';
import { useRoute, useRouter } from 'vue-router';
import { PlusCircleOutlined, MinusCircleOutlined, RollbackOutlined } from '@ant-design/icons-vue';
import { Radio, message, InputNumber } from 'ant-design-vue';
import { dragDrop } from '@/utils/format/dragDrop';
import { VueDraggableNext } from 'vue-draggable-next';
import { useDebounce } from '@/hooks/useDebounce';
import CDelModal from '@/components/CDelModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Establish',
  emits: ['getComponent'],
  setup(__props, { emit }) {

const draggable = VueDraggableNext;
const aInputNumber = InputNumber;
const aRadioGroup = Radio.Group;
const route = useRoute();
const router = useRouter();
const studioId = route.params.studioId;
const questId = route.query.id;

// 返回列表

const returnList = () => {
  emit('getComponent', 0);
};

const floatWtitleZh = ref('问卷');
const floatWtitleEh = ref('Ques');
const establishList = ref([
  {
    name: '问卷标题：',
    placeholder: '请输入问卷标题',
    model: '',
  },
  {
    name: '问卷说明：',
    placeholder: '请填写问卷说明',
    model: '',
  },
  {
    name: '结束语：',
    placeholder: '请填写问卷结束语',
    model: '感谢您的参与！',
  },
]);
const rewrite = ref(0); //重复填写
const showNumber = ref(1); //问题编号  1显示， 0不显示
const showStyle = ref(0); // 显示样式
//题目类型
const TypeList = ref([
  {
    label: '单选题',
    value: 0,
  },
  {
    label: '多选题',
    value: 1,
  },
  {
    label: '下拉题',
    value: 2,
  },
  {
    label: '填空题',
    value: 3,
  },
  {
    label: '问答题',
    value: 4,
  },
  {
    label: '评分题',
    value: 5,
  },
  {
    label: '附件上传',
    value: 6,
  },
  {
    label: '文本说明',
    value: 7,
  },
]);
const questionList = ref([
  {
    title: '', // 问题标题
    remark: '', // 问题说明
    require: false, // 0 非必填  1 必填
    type: 0, // 问题类型
    config: {
      row: 1, // 每行显示
      optional: 1, // 最多可选
      exclusion: false, // 互斥项 0关  1开
      verify: 0, // 文本验证
      measuring_type: 0, // 测量类型
      max: 100, // 最多字数
      size_row: 3, // 尺寸行
      measuring_array: [], // 量测数组
      degree1: '', // 程度
      degree2: '', // 程度
      scope: 1, // 结束数值
      initial_number: 0, // 起始数值
      inversion: false, // 反转  0关  1开
      file_size: 0, // 文件大小
      file_format: 0, // 文件格式
      loading: false, // loading  前端需要
      tiperr: false, // 文本校验指端  前端需要
      isrequire: false, //  必填没填提示语 前端需要
      ismore: false, //  上传文件大小提示 前端需要
      isformat: false, //  上传文件格式提示 前端需要
    },
    structure: [
      // 问题选项
      {
        title: '', // 选项名称
        config: false, // 选项配置 0 非互斥  1互斥项
      },
    ],
  },
]);

// 选择题型
const changeType = (item: any) => {
  if (item.type == 3) {
    item.title = '题目：_____';
  } else {
    item.title = '';
  }
};

const titleBlur = (item: any) => {
  if (item.type == 3) {
    item.title.indexOf('_') == -1 ? (item.title = item.title + '_____') : '';
  }
};

// 删除题目
const deleteModal = ref(false);
const deleteIndex = ref();
const deleteQuestion: any = (index: number) => {
  deleteIndex.value = index;
  deleteModal.value = true;
};
const deleteModalQuestion = () => {
  questionList.value.splice(deleteIndex.value, 1);
  deleteModal.value = false;
};
// 复制题目
const copyQuestion = (item: any) => {
  questionList.value.push(JSON.parse(JSON.stringify(item)));
};
// 添加题目
const addQuestion = () => {
  const questionObj = {
    title: '', // 问题标题
    remark: '', // 问题说明
    require: false, // 0 非必填  1 必填
    type: 0, // 问题类型
    config: {
      row: 1, // 每行显示
      optional: 1, // 最多可选
      exclusion: false, // 互斥项 0关  1开
      verify: 0, // 文本验证
      measuring_type: 0, // 测量类型

      max: 100, // 最多字数
      size_row: 3, // 尺寸行
      measuring_array: [], // 量测数组
      degree1: '', // 程度
      degree2: '', // 程度
      scope: 1, // 结束数值
      initial_number: 0, // 起始数值
      inversion: false, // 反转  0关  1开
      file_size: 0, // 文件大小
      file_format: 0, // 文件格式
      loading: false, // loading  前端需要
      tiperr: false, // 文本校验指端  前端需要
      isrequire: false, //  必填没填提示语 前端需要
      ismore: false, //  上传文件大小提示 前端需要
      isformat: false, //  上传文件格式提示 前端需要
    },
    structure: [
      // 问题选项
      {
        title: '', // 选项名称
        config: false, // 选项配置 0 非互斥  1互斥项
      },
    ],
  };
  questionList.value.push(questionObj);
};
// 添加选项
const addStructure = (item: any) => {
  const obj = { title: '', config: false };
  item.structure.push(obj);
};
// 删除选项
const deleteStructure = (item: any, index: number) => {
  setTimeout(() => {
    item.structure[index].config ? (mutex.value = false) : '';
    item.structure.splice(index, 1);
    if (item.config.optional > item.structure.length) {
      item.config.optional = item.structure.length;
    }
  }, 100);
};
// 互斥
const mutex = ref(false);
const checkboxMutex = (item: any, index: any, sindex: number) => {
  item.structure.forEach((i: any, j: any) => (j != sindex ? (i.config = false) : ''));
  setTimeout(() => {
    mutex.value = item.structure[sindex].config;
    if (mutex.value && item.config.optional > item.structure.length - 1) {
      item.config.optional -= 1;
    }
  }, 100);
};

const onChange = (item: any) => {
  if (!item.config.exclusion) {
    item.structure.forEach((e: any) => {
      e.config = false;
    });
    mutex.value = false;
  }
};

// 问答题：文本验证
const verifyList = ref([
  {
    label: '不限',
    value: 0,
  },
  {
    label: '数字',
    value: 3,
  },
  {
    label: '日期（如:1987-02-15）',
    value: 4,
  },
  {
    label: '邮箱',
    value: 5,
  },
  {
    label: '中文',
    value: 6,
  },
  {
    label: '英文',
    value: 7,
  },
  {
    label: '网址',
    value: 8,
  },
  {
    label: '身份证',
    value: 9,
  },
  {
    label: '手机号（仅支持中国大陆）',
    value: 10,
  },
  {
    label: '电话号（如：xxx-xxx-xxxx）',
    value: 11,
  },
]);
// 评分题：量测类型
const measuringList = ref([
  {
    label: '自定义',
    value: 0,
  },
  {
    label: '满意度',
    value: 1,
  },
  {
    label: '认同度',
    value: 2,
  },
  {
    label: '重要度',
    value: 3,
  },
  {
    label: '意愿度',
    value: 4,
  },
  {
    label: '符合度',
    value: 5,
  },
]);

// 附件上传：文件格式限制
const fileFormat = ref([
  {
    label: '不限',
    value: 0,
  },
  {
    label: '图片(JPG,PNG,GIF)',
    value: 1,
  },
  {
    label: '音视频(MOV,MP4,MP3,WMV)',
    value: 2,
  },
  {
    label: '文档(PPT,EXCEL,WORD,PDF)',
    value: 3,
  },
]);

// 保存
const toPreserve = useDebounce(() => {
  message.destroy();
  // 问卷标题验证
  if (!establishList.value[0].model) {
    message.warning('问卷标题不能为空！');
    return;
  }

  // 评分题数据处理
  questionList.value.map((item) => {
    if (item.type == 5) {
      item.config.measuring_type = String(item.config.measuring_type) as any;
      const initial_number = Number(item.config.initial_number);
      const scope = Number(item.config.scope);
      item.config.measuring_array = [];
      if (initial_number <= scope) {
        for (let k = initial_number; k <= scope; k++) {
          item.config.measuring_array.push(k as never);
        }
      } else {
        for (let k = scope; k <= initial_number; k++) {
          item.config.measuring_array.push(k as never);
        }
        item.config.measuring_array.reverse();
      }
      // 反转
      if (Number(item.config.inversion) == 1) {
        [item.config.initial_number, item.config.scope] = [item.config.scope, item.config.initial_number];
        item.config.measuring_array.reverse();
      }
    }
  });

  const data = {
    studio_id: studioId, //  直播间ID
    title: establishList.value[0].model, //  问卷标题
    desc: establishList.value[1].model, //  问卷说明
    end_remark: establishList.value[2].model, //  问卷结束语
    rewrite: rewrite.value, //  可重复填写       0否  1是
    show_number: showNumber.value, //  显示编号       0不显示  1显示
    edit_answer: '0', //  允许修改答案   0不允许 1允许
    show_style: showStyle.value, //  展示形式       0悬浮  1菜单栏
    back: '0', //  允许回退题目   0不允许  1允许
    limit_time: 0, //  限制答题时间   0不限制 单位：分钟
    items: questionList.value, //  题目
    show_title_zh: floatWtitleZh.value,
    show_title_en: floatWtitleEh.value,
  };
  if (questId) {
    // 编辑问卷
    data['id'] = questId;
    http
      .questSave(data)
      .then(() => {
        message.success('保存成功！');
        emit('getComponent', 0);
        router.push('questionnairee');
      })
      .catch((res) => {
        res.data.error ? message.error(res.data.error) : '';
      });
  } else {
    // 新建问卷
    http
      .questCreate(data)
      .then(() => {
        message.success('保存成功！');
        emit('getComponent', 0);
        router.push('questionnairee');
      })
      .catch((res) => {
        res.data.error ? message.error(res.data.error) : '';
      });
  }
});

// 获取问卷数据
const getQuestView = () => {
  const data = {
    id: questId,
    studio_id: studioId,
  };
  http.questView({ params: data }).then((res) => {
    const resData = res.data.data;
    establishList.value[0].model = resData.title;
    establishList.value[1].model = resData.desc;
    establishList.value[2].model = resData.end_remark;
    floatWtitleZh.value = resData.show_title_zh;
    floatWtitleEh.value = resData.show_title_en;
    rewrite.value = resData.rewrite;
    showNumber.value = resData.show_number;
    showStyle.value = resData.show_style;
    questionList.value = resData.items;
    // 评分题数据处理
    questionList.value.map((item) => {
      item.require = (item.require as any) == 0 ? false : true;
      item.config.exclusion;
      if (item.type == 1) {
        item.config.exclusion = (item.config.exclusion as any) == 0 ? false : true;
        item.structure.map((res) => {
          res.config = (res.config as any) == 0 ? false : true;
          res.config ? (mutex.value = true) : '';
        });
      } else if (item.type == 5) {
        item.config.measuring_type = Number(item.config.measuring_type);
        if (item.config.inversion) {
          [item.config.initial_number, item.config.scope] = [item.config.scope, item.config.initial_number];
        }
      } else if (item.type == 4) {
        item.config.verify = Number(item.config.verify);
      } else if (item.type == 6) {
        item.config.file_size = Number(item.config.file_size);
        item.config.file_format = Number(item.config.file_format);
      }
    });
  });
};
questId ? getQuestView() : '';

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_svg_icon = _resolveComponent("svg-icon")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Crumb),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_a_button, { onClick: returnList }, {
          icon: _withCtx(() => [
            _createVNode(_unref(RollbackOutlined))
          ]),
          default: _withCtx(() => [
            _createTextVNode("返回列表 ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(establishList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "establish_top align_items",
            key: index
          }, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1),
            _createVNode(_component_a_input, {
              class: "establish_top_input",
              size: "small",
              placeholder: item.placeholder,
              value: item.model,
              "onUpdate:value": ($event: any) => ((item.model) = $event)
            }, null, 8, ["placeholder", "value", "onUpdate:value"])
          ]))
        }), 128)),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_unref(aRadioGroup), {
            value: rewrite.value,
            "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((rewrite).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio, { value: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode("是")
                ]),
                _: 1
              }),
              _createVNode(_component_a_radio, { value: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode("否")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          _hoisted_8
        ]),
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createVNode(_unref(aRadioGroup), {
            value: showNumber.value,
            "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((showNumber).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_radio, { value: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode("显示")
                ]),
                _: 1
              }),
              _createVNode(_component_a_radio, { value: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode("不显示")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          _hoisted_11,
          _createVNode(_component_a_select, {
            class: "establish_top_select",
            value: showStyle.value,
            "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((showStyle).value = $event))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_select_option, { value: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode("浮窗")
                ]),
                _: 1
              }),
              _createVNode(_component_a_select_option, { value: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode("菜单栏")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          _hoisted_12
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createVNode(_component_a_input, {
            class: "establish_top_input",
            size: "small",
            placeholder: "请输入浮窗标题",
            value: floatWtitleZh.value,
            "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((floatWtitleZh).value = $event))
          }, null, 8, ["value"])
        ], 512), [
          [_vShow, !showStyle.value]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_15, [
          _hoisted_16,
          _createVNode(_component_a_input, {
            class: "establish_top_input",
            size: "small",
            placeholder: "Please enter the title of the floating window",
            value: floatWtitleEh.value,
            "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((floatWtitleEh).value = $event))
          }, null, 8, ["value"])
        ], 512), [
          [_vShow, !showStyle.value]
        ]),
        _createVNode(_unref(draggable), {
          class: "questionList",
          list: questionList.value,
          handle: ".question_draggable",
          onDrop: _unref(dragDrop)
        }, {
          default: _withCtx(() => [
            _createVNode(_TransitionGroup, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(questionList.value, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "question",
                    key: index
                  }, [
                    _withDirectives(_createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_svg_icon, { "icon-class": "drag_icon" })
                    ], 512), [
                      [_vShow, questionList.value.length !== 1]
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createVNode(_component_a_select, {
                          class: "question_select",
                          value: item.type,
                          "onUpdate:value": ($event: any) => ((item.type) = $event),
                          options: TypeList.value,
                          onChange: ($event: any) => (changeType(item))
                        }, null, 8, ["value", "onUpdate:value", "options", "onChange"])
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("div", null, [
                            _createVNode(_component_a_input, {
                              class: "question_input",
                              size: "small",
                              placeholder: "请输入问题名称",
                              value: item.title,
                              "onUpdate:value": ($event: any) => ((item.title) = $event),
                              maxlength: 120,
                              onBlur: ($event: any) => (titleBlur(item))
                            }, {
                              suffix: _withCtx(() => [
                                _createElementVNode("div", _hoisted_24, _toDisplayString(item.title.length) + "/120", 1)
                              ]),
                              _: 2
                            }, 1032, ["value", "onUpdate:value", "onBlur"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createElementVNode("div", null, [
                            _createVNode(_component_a_input, {
                              class: "question_input",
                              size: "small",
                              placeholder: "请输入问题说明",
                              value: item.remark,
                              "onUpdate:value": ($event: any) => ((item.remark) = $event),
                              maxlength: 120
                            }, {
                              suffix: _withCtx(() => [
                                _createElementVNode("div", _hoisted_27, _toDisplayString(item.remark.length) + "/120", 1)
                              ]),
                              _: 2
                            }, 1032, ["value", "onUpdate:value"])
                          ])
                        ]),
                        (item.type == 0 || item.type == 1 || item.type == 2)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.structure, (sitem, sindex) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "question_right_line align_items",
                                  key: sindex
                                }, [
                                  _createElementVNode("div", _hoisted_29, "选项" + _toDisplayString(sindex + 1) + "：", 1),
                                  _createVNode(_component_a_input, {
                                    class: "question_structure",
                                    size: "small",
                                    placeholder: "请输入选项内容",
                                    value: sitem.title,
                                    "onUpdate:value": ($event: any) => ((sitem.title) = $event)
                                  }, null, 8, ["value", "onUpdate:value"]),
                                  _createVNode(_unref(PlusCircleOutlined), {
                                    class: "question_structure_icon",
                                    onClick: ($event: any) => (addStructure(item))
                                  }, null, 8, ["onClick"]),
                                  _withDirectives(_createVNode(_unref(MinusCircleOutlined), {
                                    class: "question_structure_icon",
                                    onClick: ($event: any) => (deleteStructure(item, sindex))
                                  }, null, 8, ["onClick"]), [
                                    [_vShow, item.structure.length !== 1]
                                  ]),
                                  (item.type == 1 && item.config.exclusion)
                                    ? (_openBlock(), _createBlock(_component_a_checkbox, {
                                        key: 0,
                                        class: "question_right_checkbox",
                                        checked: sitem.config,
                                        "onUpdate:checked": ($event: any) => ((sitem.config) = $event),
                                        onClick: ($event: any) => (checkboxMutex(item, sitem, sindex))
                                      }, null, 8, ["checked", "onUpdate:checked", "onClick"]))
                                    : _createCommentVNode("", true)
                                ]))
                              }), 128))
                            ]))
                          : _createCommentVNode("", true),
                        (item.type == 0 || item.type == 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                              _hoisted_31,
                              _createVNode(_component_a_select, {
                                class: "question_row",
                                value: item.config.row,
                                "onUpdate:value": ($event: any) => ((item.config.row) = $event)
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_select_option, { value: 1 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("1")
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_a_select_option, { value: 2 }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("2")
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 2
                              }, 1032, ["value", "onUpdate:value"]),
                              (item.type == 1)
                                ? (_openBlock(), _createBlock(_component_a_checkbox, {
                                    key: 0,
                                    class: "question_right_checkbox",
                                    checked: item.config.exclusion,
                                    "onUpdate:checked": ($event: any) => ((item.config.exclusion) = $event),
                                    onChange: ($event: any) => (onChange(item))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("设为互斥项")
                                    ]),
                                    _: 2
                                  }, 1032, ["checked", "onUpdate:checked", "onChange"]))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true),
                        (item.type == 1)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                              _hoisted_33,
                              _createVNode(_component_a_select, {
                                class: "question_row",
                                value: item.config.optional,
                                "onUpdate:value": ($event: any) => ((item.config.optional) = $event)
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(mutex.value && item.structure.length !== 1
                        ? item.structure.length - 1
                        : item.structure.length, (litem, lindex) => {
                                    return (_openBlock(), _createBlock(_component_a_select_option, {
                                      key: lindex,
                                      value: lindex + 1
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(lindex + 1), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"]))
                                  }), 128))
                                ]),
                                _: 2
                              }, 1032, ["value", "onUpdate:value"])
                            ]))
                          : _createCommentVNode("", true),
                        (item.type == 4)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                              _hoisted_35,
                              _createVNode(_component_a_select, {
                                class: "question_text",
                                value: item.config.verify,
                                "onUpdate:value": ($event: any) => ((item.config.verify) = $event),
                                options: verifyList.value
                              }, null, 8, ["value", "onUpdate:value", "options"])
                            ]))
                          : _createCommentVNode("", true),
                        (item.type == 4)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                              _hoisted_37,
                              _createVNode(_unref(aInputNumber), {
                                id: "inputNumber",
                                value: item.config.max,
                                "onUpdate:value": ($event: any) => ((item.config.max) = $event),
                                onChange: ($event: any) => (item.config.size_row < 0 ? (item.config.size_row = 0) : '')
                              }, null, 8, ["value", "onUpdate:value", "onChange"]),
                              _createTextVNode("   字 ")
                            ]))
                          : _createCommentVNode("", true),
                        (item.type == 4)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              _hoisted_39,
                              _createVNode(_unref(aInputNumber), {
                                id: "inputNumber",
                                value: item.config.size_row,
                                "onUpdate:value": ($event: any) => ((item.config.size_row) = $event),
                                onChange: ($event: any) => (item.config.size_row < 0 ? (item.config.size_row = 0) : '')
                              }, null, 8, ["value", "onUpdate:value", "onChange"]),
                              _createTextVNode("   行 ")
                            ]))
                          : _createCommentVNode("", true),
                        (item.type == 5)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _hoisted_41,
                              _createVNode(_component_a_select, {
                                class: "question_measuring",
                                value: item.config.measuring_type,
                                "onUpdate:value": ($event: any) => ((item.config.measuring_type) = $event),
                                options: measuringList.value
                              }, null, 8, ["value", "onUpdate:value", "options"]),
                              _withDirectives(_createElementVNode("div", _hoisted_42, [
                                _hoisted_43,
                                _createVNode(_component_a_input, {
                                  class: "input_degree",
                                  value: item.config.degree1,
                                  "onUpdate:value": ($event: any) => ((item.config.degree1) = $event)
                                }, null, 8, ["value", "onUpdate:value"]),
                                _hoisted_44,
                                _createVNode(_component_a_input, {
                                  class: "input_degree",
                                  value: item.config.degree2,
                                  "onUpdate:value": ($event: any) => ((item.config.degree2) = $event)
                                }, null, 8, ["value", "onUpdate:value"])
                              ], 512), [
                                [_vShow, item.config.measuring_type == 0]
                              ]),
                              _hoisted_45,
                              _createVNode(_component_a_select, {
                                class: "question_row",
                                value: item.config.initial_number,
                                "onUpdate:value": ($event: any) => ((item.config.initial_number) = $event)
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(11, (item, index) => {
                                    return _createVNode(_component_a_select_option, {
                                      key: index,
                                      value: index
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(index), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"])
                                  }), 64))
                                ]),
                                _: 2
                              }, 1032, ["value", "onUpdate:value"]),
                              _hoisted_46,
                              _createVNode(_component_a_select, {
                                class: "question_row",
                                value: item.config.scope,
                                "onUpdate:value": ($event: any) => ((item.config.scope) = $event)
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(10, (item, index) => {
                                    return _createVNode(_component_a_select_option, {
                                      key: index,
                                      value: index + 1
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(index + 1), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"])
                                  }), 64))
                                ]),
                                _: 2
                              }, 1032, ["value", "onUpdate:value"])
                            ]))
                          : _createCommentVNode("", true),
                        (item.type == 6)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_47, [
                              _hoisted_48,
                              _createVNode(_component_a_select, {
                                class: "question_verify",
                                value: item.config.file_size,
                                "onUpdate:value": ($event: any) => ((item.config.file_size) = $event)
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(11, (item, index) => {
                                    return _createVNode(_component_a_select_option, {
                                      key: index,
                                      value: index
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(index == 0 ? '不限' : index + 'M'), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value"])
                                  }), 64))
                                ]),
                                _: 2
                              }, 1032, ["value", "onUpdate:value"])
                            ]))
                          : _createCommentVNode("", true),
                        (item.type == 6)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                              _hoisted_50,
                              _createVNode(_component_a_select, {
                                class: "question_verify",
                                value: item.config.file_format,
                                "onUpdate:value": ($event: any) => ((item.config.file_format) = $event),
                                options: fileFormat.value
                              }, null, 8, ["value", "onUpdate:value", "options"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_51, [
                      (item.type == 5)
                        ? (_openBlock(), _createBlock(_component_a_checkbox, {
                            key: 0,
                            class: "question_buttom_checkbox",
                            checked: item.config.inversion,
                            "onUpdate:checked": ($event: any) => ((item.config.inversion) = $event)
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("反转")
                            ]),
                            _: 2
                          }, 1032, ["checked", "onUpdate:checked"]))
                        : _createCommentVNode("", true),
                      _withDirectives(_createVNode(_component_a_checkbox, {
                        class: "question_buttom_checkbox",
                        checked: item.require,
                        "onUpdate:checked": ($event: any) => ((item.require) = $event)
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("必填项")
                        ]),
                        _: 2
                      }, 1032, ["checked", "onUpdate:checked"]), [
                        [_vShow, item.type !== 7]
                      ]),
                      _createVNode(_component_svg_icon, {
                        class: "cursor",
                        onClick: ($event: any) => (copyQuestion(item)),
                        "icon-class": "establish_add"
                      }, null, 8, ["onClick"]),
                      _withDirectives(_createElementVNode("div", {
                        class: "question_buttom_draggable cursor",
                        onClick: ($event: any) => (deleteQuestion(index))
                      }, [
                        _createVNode(_component_svg_icon, {
                          class: "mod_btn_icon",
                          "icon-class": "del"
                        })
                      ], 8, _hoisted_52), [
                        [_vShow, questionList.value.length !== 1]
                      ])
                    ])
                  ]))
                }), 128))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["list", "onDrop"]),
        _createElementVNode("div", _hoisted_53, [
          _createVNode(_component_svg_icon, {
            onClick: addQuestion,
            class: "establish_buttom_add",
            "icon-class": "establish_btn"
          }),
          _createVNode(_component_a_button, {
            onClick: _unref(toPreserve),
            class: "establish_buttom_btn",
            type: "primary"
          }, {
            default: _withCtx(() => [
              _createTextVNode("保存")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _createVNode(CDelModal, {
        visible: deleteModal.value,
        centered: "",
        close: () => (deleteModal.value = false),
        ok: deleteModalQuestion
      }, null, 8, ["visible", "close"])
    ])
  ], 64))
}
}

})